import * as actionTypes from './actionTypes'

import { getListingIndex } from '../../helpers/utils'
import { enqueueSnackbar } from './alert'
import emailServerAxios from '../../axios/emailServer'

export const fetchEmailServer = filterOptions => {
  return dispatch => {
    const params = {
      ...filterOptions,
      page: filterOptions ? filterOptions.page : 1,
      perPage: filterOptions ? filterOptions.perPage : 10
    }

    dispatch(fetchEmailServerStart())

    emailServerAxios
      .get('', { params })
      .then(response => {
        if (response.status === 200 && response.data.success) {
          const { current_page, from, last_page, per_page, to, total, data } = response.data.data

          const pagination = {
            currentPage: current_page,
            lastPage: last_page,
            perPage: per_page,
            from,
            to,
            total
          }

          const dataWithOption = data.map((item, index) => {
            return { ...item, index: getListingIndex(index, per_page, current_page) }
          })

          dispatch(fetchEmailServerSuccess(pagination, dataWithOption))
        }
      })
      .catch(error => {
        dispatch(fetchEmailServerFailed(error))
      })
  }
}

export const fetchEmailServerStart = () => {
  return {
    type: actionTypes.FETCH_EMAIL_SERVER_START
  }
}

export const fetchEmailServerSuccess = (pagination, records) => {
  return {
    type: actionTypes.FETCH_EMAIL_SERVER_SUCCESS,
    pagination,
    records
  }
}

export const fetchEmailServerFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_EMAIL_SERVER_FAILED,
    errorMessage
  }
}

export const fetchEmailServerById = recordId => {
  return dispatch => {
    dispatch(fetchEmailServerStart())
    emailServerAxios
      .get(`/${recordId}`)
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchEmailServerByIdSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchEmailServerFailed(error))
      })
  }
}

export const fetchEmailServerByIdSuccess = recordData => {
  return {
    type: actionTypes.FETCH_EMAIL_SERVER_BY_ID_SUCCESS,
    recordData
  }
}

export const clearSelectedEmailServerRecord = () => {
  return {
    type: actionTypes.CLEAR_SELECTED_EMAIL_SERVER_RECORD
  }
}

export const createEmailServer = (recordData, page) => {
  return dispatch => {
    dispatch(createEmailServerStart())

    emailServerAxios
      .post('', recordData)
      .then(response => {
        if (response.status === 201) {
          dispatch(
            enqueueSnackbar({
              message: 'Email Server Created',
              options: {
                variant: 'success'
              }
            })
          )
          dispatch(createEmailServerSuccess())
          dispatch(fetchEmailServer(page))
        }
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Invalid Email Server field',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.message,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(createEmailServerFailed())
      })
  }
}

export const createEmailServerStart = () => {
  return {
    type: actionTypes.CREATE_EMAIL_SERVER_START
  }
}

export const createEmailServerSuccess = () => {
  return {
    type: actionTypes.CREATE_EMAIL_SERVER_SUCCESS
  }
}

export const createEmailServerFailed = () => {
  return {
    type: actionTypes.CREATE_EMAIL_SERVER_FAILED
  }
}

export const updateEmailServer = (recordId, recordData, page) => {
  return dispatch => {
    dispatch(updateEmailServerStart())

    emailServerAxios
      .patch(`/${recordId}`, recordData)
      .then(response => {
        dispatch(
          enqueueSnackbar({
            message: 'Email Server Updated',
            options: {
              key: recordId,
              variant: 'success'
            }
          })
        )
        dispatch(updateEmailServerSuccess())
        dispatch(fetchEmailServer(page))
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Invalid Email Server field',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.message,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(updateEmailServerFailed())
      })
  }
}

export const updateEmailServerStart = () => {
  return {
    type: actionTypes.UPDATE_EMAIL_SERVER_START
  }
}

export const updateEmailServerSuccess = () => {
  return {
    type: actionTypes.UPDATE_EMAIL_SERVER_SUCCESS
  }
}

export const updateEmailServerFailed = () => {
  return {
    type: actionTypes.UPDATE_EMAIL_SERVER_FAILED
  }
}

export const deleteEmailServer = (recordId, page) => {
  return dispatch => {
    dispatch(deleteEmailServerStart())
    emailServerAxios
      .delete(`/${recordId}`)
      .then(response => {
        dispatch(
          enqueueSnackbar({
            message: 'Email Server Deleted',
            options: {
              key: recordId,
              variant: 'success'
            }
          })
        )
        dispatch(deleteEmailServerSuccess())
        dispatch(fetchEmailServer(page))
      })
      .catch(error => {
        dispatch(
          enqueueSnackbar({
            message: 'Delete failed',
            options: {
              variant: 'error'
            }
          })
        )
        dispatch(deleteEmailServerFailed())
      })
  }
}

export const deleteEmailServerStart = () => {
  return {
    type: actionTypes.DELETE_EMAIL_SERVER_START
  }
}

export const deleteEmailServerSuccess = () => {
  return {
    type: actionTypes.DELETE_EMAIL_SERVER_SUCCESS
  }
}

export const deleteEmailServerFailed = () => {
  return {
    type: actionTypes.DELETE_EMAIL_SERVER_FAILED
  }
}

export const fetchEmailServerFilterEmailServer = filter => {
  return dispatch => {
    dispatch(fetchEmailServerFilterEmailServerStart())
    emailServerAxios
      .get('/dropdown', { params: filter })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchEmailServerFilterEmailServerSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchEmailServerFilterEmailServerFailed(error))
      })
  }
}

export const fetchEmailServerFilterEmailServerStart = () => {
  return {
    type: actionTypes.FETCH_EMAIL_SERVER_FILTER_EMAIL_SERVER_START
  }
}

export const fetchEmailServerFilterEmailServerSuccess = data => {
  return {
    type: actionTypes.FETCH_EMAIL_SERVER_FILTER_EMAIL_SERVER_SUCCESS,
    data
  }
}

export const fetchEmailServerFilterEmailServerFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_EMAIL_SERVER_FILTER_EMAIL_SERVER_FAILED,
    errorMessage
  }
}
